
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33609',
  depVersions: {
  "documents-public-ui": "static-1.33609",
  "client-types": "static-1.437",
  "documents-lib": "static-1.33614",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1785",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4702",
  "highcharts": "static-8.97",
  "hs-promise-utils": "static-1.5258",
  "hs-test-utils": "static-1.7651",
  "hub-http": "static-1.5872",
  "hubspot-dlb": "static-2.1773",
  "HubStyleTokens": "static-2.11086",
  "I18n": "static-7.1535",
  "jasmine-immutable": "static-1.2678",
  "jasmine-runner": "static-1.6121",
  "lodash": "static-1.3",
  "quartz": "static-1.6535",
  "react": "static-7.174",
  "react-dlb": "static-1.68",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.65",
  "react-rhumb": "static-1.16292",
  "reporting-data": "static-1.65932",
  "reporting-testing-lib": "static-1.7866",
  "reporting-visualizations": "static-1.58009",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4412",
  "webpack-env": "static-1.54",
  "atom": "static-1.4741",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2129",
  "classnames": "static-2.10",
  "crm_schema": "static-3.90834",
  "cssUtils": "static-1.690",
  "customer-data-filters-ui": "static-1.38405",
  "customer-data-objects": "static-1.7278",
  "customer-data-property-utils": "static-1.7732",
  "data-fetching-client": "static-1.9342",
  "enviro": "static-4.371",
  "FireAlarmUi": "static-1.4204",
  "flux-actions": "static-1.294",
  "FormsCommonComponents": "static-1.84883",
  "FormUrlGenerator": "static-2.4400",
  "foundations-components": "static-1.7228",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3825",
  "HubStyle": "static-2.11394",
  "icons": "static-2.607",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6807",
  "metrics-js": "static-1.9296",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.334",
  "property-description-translator": "static-1.3528",
  "property-translator": "static-1.5082",
  "quartz-config": "static-1.313",
  "quartz-core": "static-1.5754",
  "quick-fetch": "static-1.3606",
  "raven": "static-3.5564",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5056",
  "react-virtualized": "static-2.92",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7827",
  "reference-resolvers-lite": "static-1.7759",
  "report-customization-components": "static-1.12146",
  "reporting-enablement": "static-1.21623",
  "reporting-reports": "static-1.65611",
  "reporting-snowflake": "static-1.54551",
  "reporting-ui-components": "static-2.63205",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4271",
  "sales-content-partitioning": "static-1.8603",
  "SalesContentIndexUI": "static-3.8698",
  "sanitize": "static-1.4144",
  "sanitize-text": "static-1.7808",
  "self-service-api": "static-1.9891",
  "SharedI18nStrings": "static-1.179",
  "SharedLegalStrings": "static-1.1451",
  "signup-constants": "static-1.18111",
  "signup-ui-lego-core": "static-1.20121",
  "signup-ui-url-generator": "static-2.7711",
  "styled-components": "static-2.83",
  "StyleGuideUI": "static-3.481",
  "superstore": "static-1.4436",
  "transmute": "static-2.77",
  "ui-addon-form-validation": "static-1.10664",
  "ui-addon-i18n": "static-1.10793",
  "ui-addon-react-router-dom": "static-1.9208",
  "ui-addon-upgrades": "static-9.17367",
  "ui-asset-management-lib": "static-1.10512",
  "ui-images": "static-2.1050",
  "UIComponents": "static-3.8033",
  "usage-tracker": "static-1.7004",
  "usage-tracker-container": "static-1.6994",
  "usage-tracker-core": "static-1.6854",
  "usage-tracker-public": "static-1.6815",
  "viral-links-lib": "static-1.6680",
  "hs-promise-rejection-tracking": "static-1.5234",
  "raven-hubspot": "static-1.5871",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3104",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2812",
  "quartz-webpack": "static-1.2759",
  "ai-components-ui-library": "static-1.7999",
  "amplitude-session-replay-browser": "static-1.53",
  "foundations-assets": "static-1.4498",
  "foundations-theming": "static-1.4069",
  "react-transition-group": "static-1.7",
  "usage-tracker-session-replay": "static-1.4690",
  "foundations-theming-base": "static-1.3054",
  "HeadJS": "static-2.685",
  "framer-motion": "static-1.62",
  "hs-test-utils-bend-plugin": "static-1.2762",
  "msw": "static-1.39",
  "testing-library": "static-1.145",
  "i18n-data": "static-1.214",
  "moment-timezone": "static-5.76",
  "jasmine": "static-4.4002",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7591",
  "graphql": "static-1.75",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3336",
  "persist-promise": "static-1.3352",
  "reporting-client-types": "static-1.2344",
  "hs-story-utils": "static-1.9098",
  "react-flip-move": "static-1.63",
  "hub-http-shared-msw-handlers": "static-1.9136",
  "hubspotter-http": "static-1.4355",
  "sassPrefix": "static-1.149",
  "conversations-skeleton-state": "static-1.6920",
  "crm-message-bus": "static-1.41980",
  "customer-data-filters-ui-msw-helpers": "static-1.20839",
  "customer-data-objects-ui-components": "static-1.12668",
  "customer-data-reference-ui-components": "static-1.12793",
  "customer-data-ui-utilities": "static-1.9491",
  "framework-builder-read-service-client": "static-1.3724",
  "framework-data-schema-quick-fetch": "static-1.6437",
  "framework-data-schema-resolvers": "static-1.6532",
  "inbound-db-properties-service-client": "static-1.3554",
  "multi-account-reference-resolvers": "static-1.631",
  "onboarding-tours": "static-1.16079",
  "reporting-datasets-permissions-lib": "static-1.12613",
  "ui-addon-teams": "static-1.21037",
  "apollo-stack-hubspot": "static-3.79",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67189",
  "customer-data-properties": "static-1.50379",
  "forms-ai-lib": "static-1.3782",
  "forms-utils-lib": "static-1.11913",
  "foundations-components-test-utils": "static-1.4711",
  "react-dnd-compat": "static-1.4293",
  "react-tinymce": "static-1.54251",
  "tinymce-config": "static-2.53377",
  "ui-gdpr-components": "static-1.10014",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3497",
  "floating-ui": "static-1.49",
  "react-aria": "static-1.59",
  "tanstack-table": "static-1.48",
  "trellis-assets": "static-1.919",
  "ui-fonts": "static-1.348",
  "dispatcher": "static-1.129",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.765",
  "mobile-manifest-mixins": "static-1.458",
  "quartz-auth": "static-1.210",
  "quartz-head": "static-1.200",
  "quartz-i18n": "static-1.210",
  "quartz-test": "static-1.210",
  "batch-promise": "static-1.1195",
  "external-options-client-types": "static-1.3860",
  "react-colorpicker": "static-2.9882",
  "reporting-insights-lib": "static-1.777",
  "copilot-toolkit": "static-1.10193",
  "data-quality-ui-library": "static-1.12019",
  "html-to-image": "static-1.47",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40348",
  "reporting-plugins": "static-1.9800",
  "ui-addon-draggable-compat": "static-2.3922",
  "ui-addon-opt": "static-4.8058",
  "ui-shepherd-react": "static-3.9807",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24344",
  "hubspot-apollo-client": "static-1.4548",
  "sales-templates-service-types-lib": "static-1.3871",
  "ui-business-units-lib": "static-1.8676",
  "growth-monetization-service-types": "static-1.4203",
  "merchandise-lib": "static-1.253",
  "emoji-regex": "static-1.7",
  "feature-store-service-types": "static-1.4196",
  "purchase-motions-components": "static-1.5284",
  "salesImages": "static-1.518",
  "ts-schema": "static-1.3781",
  "upgrade-management-service-types": "static-1.4187",
  "timezone-utils": "static-2.4912",
  "bender-build-tools": "static-1.2770",
  "chatspot-core": "static-1.19804",
  "bend-plugin-foundations-theming": "static-1.2552",
  "stylex": "static-1.25",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3499",
  "crm-pipelines-api-client-types": "static-1.3842",
  "multi-currency-client-types": "static-1.3399",
  "getting-started-shared-tasks": "static-1.17475",
  "growth-data-modal": "static-1.4997",
  "growth-onboarding-confetti": "static-1.2720",
  "growth-onboarding-next-action-utils": "static-1.1156",
  "navigation-components": "static-1.16883",
  "onboarding-tours-client": "static-1.4293",
  "onboarding-tours-utils": "static-1.145",
  "ui-shepherd-tracker": "static-1.7188",
  "ui-universal-auth": "static-1.8504",
  "user-context": "static-1.4755",
  "cms-field-types": "static-1.4471",
  "content-icons-ui": "static-1.2106",
  "calling-global-api": "static-1.63195",
  "calling-internal-common": "static-1.30955",
  "calling-lifecycle-internal": "static-1.64577",
  "calling-lifecycle-messages": "static-1.56871",
  "commerce-products-lib": "static-1.8440",
  "crm-links": "static-1.5912",
  "file-manager-components": "static-1.22497",
  "google-libphonenumber": "static-1.31",
  "hs-entities": "static-1.317",
  "inbounddb-objects-service-types": "static-1.3927",
  "meetings-icalendar-utils-lib": "static-1.302",
  "object-builder-ui-client": "static-1.47524",
  "pipeline-validation-client-types": "static-1.3663",
  "property-value-citations": "static-1.993",
  "pulse": "static-1.150",
  "smart-property-lib": "static-1.5389",
  "tiered-pricing": "static-1.617",
  "ui-addon-iframeable": "static-1.8672",
  "final-form": "static-1.63",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19239",
  "tinymce-themes": "static-1.55347",
  "data-token-picker": "static-1.15829",
  "hub-http-contrib": "static-1.2716",
  "interframe": "static-3.4457",
  "tinymce-data": "static-1.39462",
  "tinymce-plugins": "static-1.56491",
  "ui-addon-sales-email": "static-1.4883",
  "hubspotter-http-shared-msw-handlers": "static-1.9134",
  "magpie-lib": "static-1.5241",
  "magpie-types": "static-1.4701",
  "simple-logging-lib": "static-1.2719",
  "content-assistance-lib": "static-1.7255",
  "dashboard-lib": "static-1.80098",
  "ExportDialog": "static-6.10054",
  "hubspot-prosemirror": "static-1.17246",
  "hubspot-prosemirror-plugins": "static-1.17238",
  "integrations-lib": "static-1.14987",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8355",
  "campaign-roi-lib": "static-1.7887",
  "feedback-loader": "static-1.28623",
  "commerce-analytics-service-client": "static-1.3350",
  "onboarding-scopes": "static-1.6110",
  "apollo-link-hub-http": "static-2.4317",
  "hubspot-apollo-cache": "static-1.7",
  "nav-client-types": "static-1.2000",
  "purchase-motions-api": "static-1.5287",
  "trials-service-types": "static-1.3604",
  "chatspot-client-types": "static-1.10310",
  "idb-keyval": "static-1.37",
  "reactive-lib": "static-1.394",
  "getting-started-shared-tasks-store": "static-1.16593",
  "calling-error-reporting": "static-1.30961",
  "shared-worker-versioning": "static-1.10685",
  "calling-usage-tracker": "static-1.6207",
  "calling-orchestration-shared-library": "static-1.34384",
  "customer-data-tracking": "static-1.6529",
  "products-iframe-lib": "static-1.6997",
  "products-ui-components-shared-msw-handlers": "static-1.9518",
  "location-customization-utils-lib": "static-1.8128",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3823",
  "video-components-external": "static-1.10155",
  "video-data-lib": "static-1.33813",
  "directed-graph": "static-1.603",
  "event-emitter": "static-1.594",
  "breeze-intelligence-kit": "static-1.5126",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9219",
  "fsm": "static-1.3398",
  "policy-lib": "static-1.6470",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9282",
  "navigation-messaging": "static-1.6210",
  "FileManagerLib": "static-1.38137",
  "NamespacedHubStyle": "static-2.8779",
  "FileManagerCore": "static-1.37996",
  "codemirror": "static-5.88",
  "layout-dnd-components": "static-1.11800",
  "layout-dnd-utils": "static-1.10775",
  "react-codemirror": "static-1.10270",
  "ui-addon-emoji-picker": "static-1.9559",
  "ui-brand-identity-lib": "static-1.13328",
  "ui-addon-video-player": "static-1.8390",
  "ui-coaching-tips": "static-1.27570",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8266",
  "payment-link-components": "static-1.22570",
  "EmailSignatureEditor": "static-1.23682",
  "integrations-error-boundary-lib": "static-1.12402",
  "integrations-tracking-lib": "static-1.5251",
  "native-integrations-shared-strings": "static-1.7455",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10043",
  "rxjs": "static-5.10",
  "eligibility-engine-service-types": "static-1.2885",
  "calling-orchestration-schema": "static-1.34609",
  "sales-views-client-types": "static-1.3960",
  "crm-record-cards-service-types": "static-1.3336",
  "content-media-composition-data-lib": "static-1.10877",
  "content-media-compositions": "static-2.14884",
  "media-bridge-lib": "static-1.18354",
  "trellis-story-utils": "static-1.4192",
  "storybook-react": "static-1.26",
  "audio-components": "static-1.5423",
  "FileManagerImages": "static-1.35648",
  "video-components": "static-1.12158",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4193",
  "video-embed": "static-1.34647",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67264",
  "layout-data-lib": "static-1.9100",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6254",
  "commerce-tours-lib": "static-1.5512",
  "growth-onboarding-reliability": "static-1.4757",
  "sales-checkout-service-client": "static-1.3362",
  "draft-convert": "static-2.31",
  "draft-extend": "static-2.46",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.21078",
  "sales-email-signature-service-client": "static-1.3507",
  "universal-page-editor-lib": "static-1.2665",
  "hls.js": "static-1.32",
  "social-insights-client-types": "static-1.21037",
  "outpost": "static-1.3884",
  "advanced-menus-core": "static-1.14605",
  "advanced-menus-lib": "static-1.11606",
  "ui-memberships-settings-lib": "static-1.33060",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14604",
  "simple-menus-lib": "static-1.16121"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33609",
  "client-types": "/client-types/static-1.437",
  "documents-lib": "/documents-lib/static-1.33614",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1785",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4702",
  "highcharts": "/highcharts/static-8.97",
  "hs-promise-utils": "/hs-promise-utils/static-1.5258",
  "hs-test-utils": "/hs-test-utils/static-1.7651",
  "hub-http": "/hub-http/static-1.5872",
  "hubspot-dlb": "/hubspot-dlb/static-2.1773",
  "HubStyleTokens": "/HubStyleTokens/static-2.11086",
  "I18n": "/I18n/static-7.1535",
  "jasmine-immutable": "/jasmine-immutable/static-1.2678",
  "jasmine-runner": "/jasmine-runner/static-1.6121",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6535",
  "react": "/react/static-7.174",
  "react-dlb": "/react-dlb/static-1.68",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.65",
  "react-rhumb": "/react-rhumb/static-1.16292",
  "reporting-data": "/reporting-data/static-1.65932",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.7866",
  "reporting-visualizations": "/reporting-visualizations/static-1.58009",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4412",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4741",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2129",
  "classnames": "/classnames/static-2.10",
  "crm_schema": "/crm_schema/static-3.90834",
  "cssUtils": "/cssUtils/static-1.690",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38405",
  "customer-data-objects": "/customer-data-objects/static-1.7278",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7732",
  "data-fetching-client": "/data-fetching-client/static-1.9342",
  "enviro": "/enviro/static-4.371",
  "FireAlarmUi": "/FireAlarmUi/static-1.4204",
  "flux-actions": "/flux-actions/static-1.294",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.84883",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4400",
  "foundations-components": "/foundations-components/static-1.7228",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3825",
  "HubStyle": "/HubStyle/static-2.11394",
  "icons": "/icons/static-2.607",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6807",
  "metrics-js": "/metrics-js/static-1.9296",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.334",
  "property-description-translator": "/property-description-translator/static-1.3528",
  "property-translator": "/property-translator/static-1.5082",
  "quartz-config": "/quartz-config/static-1.313",
  "quartz-core": "/quartz-core/static-1.5754",
  "quick-fetch": "/quick-fetch/static-1.3606",
  "raven": "/raven/static-3.5564",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5056",
  "react-virtualized": "/react-virtualized/static-2.92",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7827",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7759",
  "report-customization-components": "/report-customization-components/static-1.12146",
  "reporting-enablement": "/reporting-enablement/static-1.21623",
  "reporting-reports": "/reporting-reports/static-1.65611",
  "reporting-snowflake": "/reporting-snowflake/static-1.54551",
  "reporting-ui-components": "/reporting-ui-components/static-2.63205",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4271",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8603",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8698",
  "sanitize": "/sanitize/static-1.4144",
  "sanitize-text": "/sanitize-text/static-1.7808",
  "self-service-api": "/self-service-api/static-1.9891",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1451",
  "signup-constants": "/signup-constants/static-1.18111",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20121",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7711",
  "styled-components": "/styled-components/static-2.83",
  "StyleGuideUI": "/StyleGuideUI/static-3.481",
  "superstore": "/superstore/static-1.4436",
  "transmute": "/transmute/static-2.77",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10664",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10793",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9208",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17367",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10512",
  "ui-images": "/ui-images/static-2.1050",
  "UIComponents": "/UIComponents/static-3.8033",
  "usage-tracker": "/usage-tracker/static-1.7004",
  "usage-tracker-container": "/usage-tracker-container/static-1.6994",
  "usage-tracker-core": "/usage-tracker-core/static-1.6854",
  "usage-tracker-public": "/usage-tracker-public/static-1.6815",
  "viral-links-lib": "/viral-links-lib/static-1.6680",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5234",
  "raven-hubspot": "/raven-hubspot/static-1.5871",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3104",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2812",
  "quartz-webpack": "/quartz-webpack/static-1.2759",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.7999",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.53",
  "foundations-assets": "/foundations-assets/static-1.4498",
  "foundations-theming": "/foundations-theming/static-1.4069",
  "react-transition-group": "/react-transition-group/static-1.7",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4690",
  "foundations-theming-base": "/foundations-theming-base/static-1.3054",
  "HeadJS": "/HeadJS/static-2.685",
  "framer-motion": "/framer-motion/static-1.62",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2762",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.145",
  "i18n-data": "/i18n-data/static-1.214",
  "moment-timezone": "/moment-timezone/static-5.76",
  "jasmine": "/jasmine/static-4.4002",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7591",
  "graphql": "/graphql/static-1.75",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3336",
  "persist-promise": "/persist-promise/static-1.3352",
  "reporting-client-types": "/reporting-client-types/static-1.2344",
  "hs-story-utils": "/hs-story-utils/static-1.9098",
  "react-flip-move": "/react-flip-move/static-1.63",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9136",
  "hubspotter-http": "/hubspotter-http/static-1.4355",
  "sassPrefix": "/sassPrefix/static-1.149",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6920",
  "crm-message-bus": "/crm-message-bus/static-1.41980",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.20839",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12668",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12793",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9491",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3724",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6437",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6532",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3554",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.631",
  "onboarding-tours": "/onboarding-tours/static-1.16079",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12613",
  "ui-addon-teams": "/ui-addon-teams/static-1.21037",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67189",
  "customer-data-properties": "/customer-data-properties/static-1.50379",
  "forms-ai-lib": "/forms-ai-lib/static-1.3782",
  "forms-utils-lib": "/forms-utils-lib/static-1.11913",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4711",
  "react-dnd-compat": "/react-dnd-compat/static-1.4293",
  "react-tinymce": "/react-tinymce/static-1.54251",
  "tinymce-config": "/tinymce-config/static-2.53377",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10014",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3497",
  "floating-ui": "/floating-ui/static-1.49",
  "react-aria": "/react-aria/static-1.59",
  "tanstack-table": "/tanstack-table/static-1.48",
  "trellis-assets": "/trellis-assets/static-1.919",
  "ui-fonts": "/ui-fonts/static-1.348",
  "dispatcher": "/dispatcher/static-1.129",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.765",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.458",
  "quartz-auth": "/quartz-auth/static-1.210",
  "quartz-head": "/quartz-head/static-1.200",
  "quartz-i18n": "/quartz-i18n/static-1.210",
  "quartz-test": "/quartz-test/static-1.210",
  "batch-promise": "/batch-promise/static-1.1195",
  "external-options-client-types": "/external-options-client-types/static-1.3860",
  "react-colorpicker": "/react-colorpicker/static-2.9882",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.777",
  "copilot-toolkit": "/copilot-toolkit/static-1.10193",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12019",
  "html-to-image": "/html-to-image/static-1.47",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40348",
  "reporting-plugins": "/reporting-plugins/static-1.9800",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.3922",
  "ui-addon-opt": "/ui-addon-opt/static-4.8058",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9807",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24344",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4548",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3871",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8676",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4203",
  "merchandise-lib": "/merchandise-lib/static-1.253",
  "emoji-regex": "/emoji-regex/static-1.7",
  "feature-store-service-types": "/feature-store-service-types/static-1.4196",
  "purchase-motions-components": "/purchase-motions-components/static-1.5284",
  "salesImages": "/salesImages/static-1.518",
  "ts-schema": "/ts-schema/static-1.3781",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4187",
  "timezone-utils": "/timezone-utils/static-2.4912",
  "bender-build-tools": "/bender-build-tools/static-1.2770",
  "chatspot-core": "/chatspot-core/static-1.19804",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2552",
  "stylex": "/stylex/static-1.25",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3499",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3842",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3399",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17475",
  "growth-data-modal": "/growth-data-modal/static-1.4997",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2720",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1156",
  "navigation-components": "/navigation-components/static-1.16883",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4293",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.145",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7188",
  "ui-universal-auth": "/ui-universal-auth/static-1.8504",
  "user-context": "/user-context/static-1.4755",
  "cms-field-types": "/cms-field-types/static-1.4471",
  "content-icons-ui": "/content-icons-ui/static-1.2106",
  "calling-global-api": "/calling-global-api/static-1.63195",
  "calling-internal-common": "/calling-internal-common/static-1.30955",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64577",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.56871",
  "commerce-products-lib": "/commerce-products-lib/static-1.8440",
  "crm-links": "/crm-links/static-1.5912",
  "file-manager-components": "/file-manager-components/static-1.22497",
  "google-libphonenumber": "/google-libphonenumber/static-1.31",
  "hs-entities": "/hs-entities/static-1.317",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3927",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.302",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47524",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3663",
  "property-value-citations": "/property-value-citations/static-1.993",
  "pulse": "/pulse/static-1.150",
  "smart-property-lib": "/smart-property-lib/static-1.5389",
  "tiered-pricing": "/tiered-pricing/static-1.617",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8672",
  "final-form": "/final-form/static-1.63",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19239",
  "tinymce-themes": "/tinymce-themes/static-1.55347",
  "data-token-picker": "/data-token-picker/static-1.15829",
  "hub-http-contrib": "/hub-http-contrib/static-1.2716",
  "interframe": "/interframe/static-3.4457",
  "tinymce-data": "/tinymce-data/static-1.39462",
  "tinymce-plugins": "/tinymce-plugins/static-1.56491",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4883",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9134",
  "magpie-lib": "/magpie-lib/static-1.5241",
  "magpie-types": "/magpie-types/static-1.4701",
  "simple-logging-lib": "/simple-logging-lib/static-1.2719",
  "content-assistance-lib": "/content-assistance-lib/static-1.7255",
  "dashboard-lib": "/dashboard-lib/static-1.80098",
  "ExportDialog": "/ExportDialog/static-6.10054",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17246",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17238",
  "integrations-lib": "/integrations-lib/static-1.14987",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8355",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.7887",
  "feedback-loader": "/feedback-loader/static-1.28623",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3350",
  "onboarding-scopes": "/onboarding-scopes/static-1.6110",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4317",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.7",
  "nav-client-types": "/nav-client-types/static-1.2000",
  "purchase-motions-api": "/purchase-motions-api/static-1.5287",
  "trials-service-types": "/trials-service-types/static-1.3604",
  "chatspot-client-types": "/chatspot-client-types/static-1.10310",
  "idb-keyval": "/idb-keyval/static-1.37",
  "reactive-lib": "/reactive-lib/static-1.394",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16593",
  "calling-error-reporting": "/calling-error-reporting/static-1.30961",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10685",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6207",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34384",
  "customer-data-tracking": "/customer-data-tracking/static-1.6529",
  "products-iframe-lib": "/products-iframe-lib/static-1.6997",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9518",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8128",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3823",
  "video-components-external": "/video-components-external/static-1.10155",
  "video-data-lib": "/video-data-lib/static-1.33813",
  "directed-graph": "/directed-graph/static-1.603",
  "event-emitter": "/event-emitter/static-1.594",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5126",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9219",
  "fsm": "/fsm/static-1.3398",
  "policy-lib": "/policy-lib/static-1.6470",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9282",
  "navigation-messaging": "/navigation-messaging/static-1.6210",
  "FileManagerLib": "/FileManagerLib/static-1.38137",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8779",
  "FileManagerCore": "/FileManagerCore/static-1.37996",
  "codemirror": "/codemirror/static-5.88",
  "layout-dnd-components": "/layout-dnd-components/static-1.11800",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10775",
  "react-codemirror": "/react-codemirror/static-1.10270",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9559",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13328",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8390",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27570",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8266",
  "payment-link-components": "/payment-link-components/static-1.22570",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23682",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12402",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5251",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7455",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10043",
  "rxjs": "/rxjs/static-5.10",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2885",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34609",
  "sales-views-client-types": "/sales-views-client-types/static-1.3960",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3336",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.10877",
  "content-media-compositions": "/content-media-compositions/static-2.14884",
  "media-bridge-lib": "/media-bridge-lib/static-1.18354",
  "trellis-story-utils": "/trellis-story-utils/static-1.4192",
  "storybook-react": "/storybook-react/static-1.26",
  "audio-components": "/audio-components/static-1.5423",
  "FileManagerImages": "/FileManagerImages/static-1.35648",
  "video-components": "/video-components/static-1.12158",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4193",
  "video-embed": "/video-embed/static-1.34647",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67264",
  "layout-data-lib": "/layout-data-lib/static-1.9100",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6254",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5512",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4757",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3362",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-2.46",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.21078",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3507",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2665",
  "hls.js": "/hls.js/static-1.32",
  "social-insights-client-types": "/social-insights-client-types/static-1.21037",
  "outpost": "/outpost/static-1.3884",
  "advanced-menus-core": "/advanced-menus-core/static-1.14605",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11606",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33060",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14604",
  "simple-menus-lib": "/simple-menus-lib/static-1.16121"
}
};
